import React from "react";
import "../../styles/RefundTab.css";

const RefundTab = ({ payment }) => {

    const refund = payment?.refund;

    if (!refund) {

        return (
            <div className="refund-card">
                <h3>No Refund Information</h3>
            </div>
        );

    }

    return (

        <div className="refund-card">

            <h3>Refund Details</h3>

            <div className="refund-grid">

                <div>
                    <label>Status</label>
                    <p>{refund.status}</p>
                </div>

                <div>
                    <label>Amount</label>
                    <p>₹{refund.amount}</p>
                </div>

                <div>
                    <label>Reason</label>
                    <p>{refund.reason}</p>
                </div>

                <div>
                    <label>Refund ID</label>
                    <p>{refund.refundId || "-"}</p>
                </div>

            </div>

        </div>

    );

};

export default RefundTab;